import { render, staticRenderFns } from "./PuppyReleaseKennelSignature.vue?vue&type=template&id=42fbe088"
import script from "./PuppyReleaseKennelSignature.vue?vue&type=script&lang=ts"
export * from "./PuppyReleaseKennelSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports